import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentoPreEditadoService } from '../../_services/DocumentoPreEditado.service';
import { DocumentoPreEditado } from '../../_models/DocumentoPreEditado';
import { Message, User } from '../../_models';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
    selector: 'app-protocolos-pendetes-aprovacao-comercial',
    templateUrl: './protocolos-pendetes-aprovacao-comercial.component.html',
    styleUrls: ['./protocolos-pendetes-aprovacao-comercial.component.css']
})

export class ProtocolosPendetesAprovacaoComercialComponent implements OnInit {
    currentUser: User;
    messageModel: Message;
    lstProtocolos = new Array<DocumentoPreEditado>();
    loadProtocolos = true;
    displayedColumns: string[] = [
        'idProtocolo',
        'documento',
        'nomeFornecedor',
        'cpf',
        'dataEmissaoNf',
        'dataVencimentoNf',
        'dataCriacao',
        'valor',
        'select'
    ];
    dataSource = new MatTableDataSource<DocumentoPreEditado>(this.lstProtocolos);
    selection = new SelectionModel<DocumentoPreEditado>(true, []);

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    constructor(
        private apiProtocolos: DocumentoPreEditadoService,
        private dialog?: MatDialog,
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

    ngOnInit() {
        this.apiProtocolos.obterUltimosProtocoloPendentesRpa().subscribe(
            rtn => this.lstProtocolos = rtn.data,
            err => {
                console.log(err);
                this.messageModel = new Message(
                    'Protocolos',
                    'Erro de conexão',
                    'Ocorreu um erro ao listar os ultimos protocolos da base. Tente novamente.',
                    'warning'
                );
                this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
                this.loadProtocolos = false;
            },
            () => {
                this.apiProtocolos.sanitizarDiretorioUpload().subscribe(err => { }, () => { });
                this.dataSource = new MatTableDataSource<DocumentoPreEditado>(this.lstProtocolos);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.loadProtocolos = false;
            }
        );
    }

    NavigateProtocolo(documento: string) {
        localStorage.setItem('documento', JSON.stringify(documento));
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    formatarCPF(cpf: string): string {
        // Remova caracteres não numéricos
        cpf = cpf.replace(/\D/g, '');
    
        // Formate o CPF (XXX.XXX.XXX-XX)
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
}
